module.exports = __webpack_public_path__ + "static/media/utilidade.96737968.jpg";